import { CrewMember } from '@legacy-types';

import { AccessVouchersDataTable } from '@shared/access-vouchers/components';
import { getAccessVouchersForRegistration } from '@shared/access-vouchers/endpoints/getAccessVouchersForRegistration';
import { useData } from '@shared/api/hooks/useData';
import { PartialQuery } from '@shared/api/types';
import { Portlet } from '@shared/ui/components/Portlet';

type AccessVoucherData = App.Domain.Wristband.Data.AccessVoucherData;

type ShowUserRegistrationAccessVouchersProps = {
  crewMember: CrewMember;
};

export function ShowUserRegistrationAccessVouchers({ crewMember }: ShowUserRegistrationAccessVouchersProps) {
  const accessVouchers = useData<AccessVoucherData>({
    get: (query: PartialQuery) => getAccessVouchersForRegistration(crewMember.registrationId, query),
    query: {
      filter: { crew_member_id: crewMember.id },
      include: ['accessVoucherTemplate.period', 'crewMember.registration'],
      page: { size: 20 },
    },
    history: false,
  });

  return (
    <Portlet title="Access Vouchers">
      <AccessVouchersDataTable accessVouchers={accessVouchers} avoidPagination withoutFilters />
    </Portlet>
  );
}
